<template>
  <div class="container">
    <div class="nav">
      <Btnav></Btnav>
    </div>

    <div
      class="banner"
      :style=" 'background-image: url(' + this.banner + ');background-size: cover;'"
    >
      <p class="bannerp1">{{bannerp1}}</p>
      <p class="bannerp2">{{bannerp2}}</p>
    </div>
    <div class="inn">
      <div class="inn1">
        <div class="inn1-1">
          <img class="innimgl" src="../../assets/dashu/c_1.png" alt />
          <img class="innimgr" src="../../assets/dashu/c_2.png" alt />
          <div class="inntitle1">{{inntitle1}}</div>
          <div class="inndesc1">{{inndesc1}}</div>
          <div class="inntitle2">{{inntitle2}}</div>
          <div class="inndesc2">{{inndesc2}}</div>
        </div>
        <div class="inn1-2">
          <p class="inn1-2pp">{{inn12pp}}</p>
          <div class="inn1-2-1">
            <div class="inn1-2-1-1">
              <img class src="../../assets/dashu/inn2.jpg" alt />
              <div class="con">
                <p class="innp1">{{innp1}}</p>
                <p class="innp2">{{innp2}}</p>
              </div>
            </div>
            <div class="inn1-2-1-1 inncenter">
              <img class src="../../assets/dashu/inn4.jpg" alt />
              <div class="con">
                <p class="innp1">{{innp3}}</p>
                <p class="innp2">{{innp4}}</p>
              </div>
            </div>
            <div class="inn1-2-1-1">
              <img class src="../../assets/dashu/inn5.jpg" alt />
              <div class="con">
                <p class="innp1">{{innp5}}</p>
                <p class="innp2">{{innp6}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="inn2">
        <p class="inn1-2p">{{inn2_1}}</p>
        <div class="inn2-2-1">
          <div class="inn2-2-1-1">
            <img class="inn2-img" src="../../assets/dashu/inn6.jpg" alt />
            <p class="innp1_2">{{inn2_2}}</p>
            <ul>
              <li>{{inn2_3}}</li>
              <li>{{inn2_4}}</li>
              <li>{{inn2_5}}</li>
            </ul>
          </div>
          <div class="inn2-2-1-1">
            <img class="inn2-img" src="../../assets/dashu/inn7.jpg" alt />
            <p class="innp1_2">{{inn2_6}}</p>
            <ul>
              <li>{{inn2_7}}</li>
              <li>{{inn2_8}}</li>
              <li>{{inn2_9}}</li>
              <li>{{inn2_10}}</li>
            </ul>
          </div>
        </div>
        <div class="inn2-2-1">
          <div class="inn2-2-1-1">
            <img class="inn2-img" src="../../assets/dashu/inn8.jpg" alt />
            <p class="innp1_2">{{inn2_11}}</p>
            <ul>
              <li>{{inn2_12}}</li>
              <li>{{inn2_13}}</li>
            </ul>
          </div>
          <div class="inn2-2-1-1">
            <img class="inn2-img" src="../../assets/dashu/inn9.png" alt />
            <p class="innp1_2">{{inn2_14}}</p>
            <ul>
              <li>{{inn2_15}}</li>
              <li>{{inn2_16}}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="inn3">
        <p class="inn1-2ppp">{{inn3_1}}</p>
        <div class="inn2-2-1">
          <div class="inn3-2-1-1">
            <p class="innp3">{{inn3_2}}</p>
            <ul>
              <li>{{inn3_3}}</li>
              <li>{{inn3_4}}</li>
              <li>{{inn3_5}}</li>
            </ul>
          </div>
          <div class="inn3-2-1-1">
            <p class="innp3">{{inn3_6}}</p>
            <ul>
              <li>{{inn3_7}}</li>
              <li>{{inn3_8}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <Btfooter></Btfooter>
  </div>
</template>
<script>
import Btnav from "../../components/dashu/nav";
import Btfooter from "../../components/dashu/footer";
export default {
  components: { Btnav, Btfooter },
  data() {
    return {
      ischinese: "cn",
      banner: "",
      currentPage4: 1,
      bannerp1: "创新",
      bannerp2: "烙印在大树血液里的文化基因",
      inntitle1: "大树的创新",
      inndesc1:
        "聚集国内外优秀人才，聚焦新技术及产品研究，以开放互联的理念，驱动企业创新发展。服务全球品牌用户，实现多语言，全球化，全渠道，理想的电商自运营；打造数据标准化，服务标准化的云计算平台，为云生态平台提供坚实的基础。",
      inntitle2: "创新布局",
      inndesc2:
        "战略布局基础云计算，电商云生态，大树大脑，大数据平台四大科技创新方向，为实现大树电商创新愿景不懈努力。",
      inn12pp: "创新优势",
      innp1: "先进的实施理念",
      innp2:
        "以产品思维取代项目思维，将产品化的理念彻底贯彻到创新的每一个环节，每一个员工。",
      innp3: "牢靠的根基",
      innp4:
        "先进的云计算技术平台，支撑起以大树多年品牌电商运营经验培育的电商云生态平台。",
      innp5: "标准化能力",
      innp6:
        "通过标准化的数据，打造标准产品，使大树具备提供标准化科技服务的能力。",
      inn2_1: "创新服务",
      inn2_2: "云计算平台",
      inn2_3: "SaaS化的电商计算平台",
      inn2_4: "提供标准化的服务接口与数据接口",
      inn2_5: "电商基础服务化产品",
      inn2_6: "先进的实施理念",
      inn2_7: "SaaS化的电子商务应用平台",
      inn2_8: "面向不同体量级别的品牌客户",
      inn2_9: "依照需求制定规划，精简流程",
      inn2_10: "优化预算支出与业务能力",
      inn2_11: "大树大脑",
      inn2_12:
        "基于大数据和深度学习，识别图片、视频中的视觉内容，应用于商品识别、商品推荐、趋势分析等场景",
      inn2_13:
        "构建知识图谱，描述产品与产品、产品与客户关系链路，挖掘潜在商业机会",
      inn2_14: "大数据平台",
      inn2_15:
        "以核心技术能力为依托，提供数据产品和分析服务与国内外知名学府深度合作智能工具",
      inn2_16: "提升商业效率，开拓业务场景，优化用户体验",
      inn3_1: "前沿研究",
      inn3_2: "图像数据深度研究",
      inn3_3: "通过技术手段采集数据",
      inn3_4: "由图像识别和深度学习方法获得有价值结论",
      inn3_5: "为品牌产品运营提供科学依据",
      inn3_6: "校企合作",
      inn3_7: "共同建立科学实验室",
      inn3_8: "将研究成果与企业日常运作结合"
    };
  },
  created() {
    this.ischinese = window.localStorage.getItem("ischinese") || "cn";
    if (this.ischinese == "en") {
      this.bannerp1 = "Innovation";
      this.bannerp2 = "Cultural Genes Imprinted in the Blood of Dashu";
      this.inntitle1 = "The Innovation of Dashu";
      this.inndesc1 =
        "We will gather outstanding talents at home and abroad, focus on new technologies and product research, and drive the innovation and development of enterprises with the concept of open interconnection. We serve global brand users and realize multilingual, global, full-channel and ideal e-commerce self-operation. We build a cloud computing platform for data standardization and service standardization to lay a solid foundation for the cloud ecological platform.";
      this.inntitle2 = "Innovative Layout";
      this.inndesc2 =
        "The strategic layout is based on four major scientific and technological innovation directions: basic cloud computing, e-commerce cloud ecology, Dashu brain and big data platform, making unremitting efforts to realize the vision of Dashu e-commerce innovation.";
      this.inn12pp = "Innovation Advantage";
      this.innp1 = "Advanced Implementation Concept";
      this.innp2 =
        "Dashu replaces project thinking with product thinking, and thoroughly implement the product concept to every link of innovation and every employee.";
      this.innp3 = "Solid Foundation";
      this.innp4 =
        "The advanced cloud computing technology platform supports the e-commerce cloud ecological platform, which is cultivated by Dashu for many years of brand e-commerce operation experience.";
      this.innp5 = "Standardization Capability";
      this.innp6 =
        "We create standardized products through standardized data so that Dashu can provide standardized scientific and technological services.";
      this.inn2_1 = "Innovative Service";
      this.inn2_2 = "Cloud Computing Platform";
      this.inn2_3 = "E-commerce Computing Platform Based on SaaS";
      this.inn2_4 = "Provide Standardized Service Interface and Data Interface";
      this.inn2_5 = "E-commerce Basic Service Products";
      this.inn2_6 = "Advanced Implementation Concept";
      this.inn2_7 = "E-commerce Application Platform Based on SaaS";
      this.inn2_8 = "Face Brand Customers of Different Size Levels";
      this.inn2_9 = "Plan and Streamline Processes According to Needs";
      this.inn2_10 = "Optimize Budget Expenditure and Business Capability";
      this.inn2_11 = "Dashu Brain";
      this.inn2_12 =
        "Based on big data and in-depth learning, visual content in pictures and videos is identified and applied to scenes such as commodity identification, commodity recommendation and trend analysis.";
      this.inn2_13 =
        "Build knowledge maps, describe product-to-product, product-to-customer relationship links, and tap potential business opportunities.";
      this.inn2_14 = "Big Data Platform";
      this.inn2_15 =
        "Relying on its core technical capabilities, it provides data products, analysis services and intelligent tools for in-depth cooperation with well-known universities at home and abroad.";
      this.inn2_16 =
        "Improve business efficiency, develop business scenarios, and optimize the user experience.";
      this.inn3_1 = "Frontier Research";
      this.inn3_2 = "Research on Depth of Image Data";
      this.inn3_3 = "Collect data by technical means";
      this.inn3_4 =
        "Valuable conclusions are obtained through image recognition and depth learning methods.";
      this.inn3_5 = "Provide Scientific Basis for Brand Product Operation";
      this.inn3_6 = "School-enterprise Cooperation";
      this.inn3_7 = "Joint Establishment of Scientific Laboratories";
      this.inn3_8 =
        "Combine the research results with the daily operation of the enterprise.";
    }
    this.$http
      .post("/api/dashu/innovate/innovateList", {})
      .then(res => {
        // console.log(res.data.data)
        var code = res.data.code;
        if (code === 0) {
          this.banner = res.data.data.banner.image;
          //  console.log(this.banner)
        }
      })
      .catch(function(error) {
        //  console.log(error);
      });
  },
  methods: {}
};
</script>
<style scoped>
body {
  position: relative;
}
ul li {
  list-style-type: square;
  margin-left: 10px;
  color: grey;
  font-size: 16px;
  padding: 0 70px 5px 0;
  line-height: 30px;
}
.container {
  background-color: white;
  min-width: max-content;
  min-width: -moz-max-content;
}
.nav {
  overflow: hidden !important;
}
.nav {
  position: absolute;
  top: 0;
  z-index: 10;
  width: 100%;
  min-width: 1200px;
  /* background-size: 100% 100%; */
  background-position: center center;
  background-repeat: no-repeat;
}
.banner {
  overflow: hidden !important;
  position: relative;
  /* background-size: 100% 100%; */
  background-position: center center;
  background-repeat: no-repeat;
  width: 100%;
  min-width: 1200px;
  height: 608px;
  /* margin-top: 57px; */
  text-align: center;
}
.bannerp1 {
  /* position: absolute;
  top: 175px;
  left: 500px; */
  margin-top: 175px;
  font-size: 38px;
  font-weight: bold;
  color: white;
}
.bannerp2 {
  /* position: absolute;
  top: 270px;
  left: 500px; */
  margin: 0 auto;
  font-size: 20px;
  width: 270px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: white;
  text-align: center;
}
.inn {
  /* width:1900px; */
  background: white;
}
.inn1 {
  /* height: 1260px; */
  height: 1300px;
  width: 1180px;
  background: white;
  margin: 140px auto 0;
}
.inn1-1 {
  height: 655px;
  width: 1180px;
  background: white;
  position: relative;
  margin-bottom: 140px;
}
.innimgl {
  position: absolute;
  top: 0;
  left: 0;
}
.innimgr {
  position: absolute;
  top: 0;
  right: 0;
}
.inn1-2p {
  font-size: 30px;
  font-weight: bold;
  width: 1180px;
  margin: 40px auto 10px;
  padding-top: 70px;
}
.inn1-2pp {
  font-size: 30px;
  font-weight: bold;
  width: 1180px;
  margin: 40px auto 0px;
  padding-bottom: 76px;
}
.inn1-2ppp {
  font-size: 30px;
  font-weight: bold;
  width: 1180px;
  margin: 70px auto 70px;
}
.innp1 {
  text-align: left;
  color: #fff;
  font-size: 22px;
  margin: 0;
  margin-bottom: 25px;
}
.innp1_2 {
  text-align: left;
  color: #3b4f41;
  font-size: 22px;
  margin: 0;
  margin-bottom: 25px;
}
.innp3 {
  color: black;
  font-size: 22px;
  margin-bottom: 30px;
}
.innp2 {
  color: #fff;
  font-size: 16px;
  line-height: 30px;
  text-align: left;
  margin: 0;
}
.inn1-2 {
  height: 355px;
  width: 1180px;
  background: white;
}
.inn1-2-1 {
  display: flex;
  width: 1180px;
}
.inn1-2-1-1 {
  width: 30%;
  text-align: center;
}
.inncenter {
  margin: 0 5%;
}

.inn2 {
  margin: 20px auto 0;
  width: 100%;
  background: #f3f3f3;
}
.inn2-2-1 {
  display: flex;
  width: 1180px;
  margin: 0 auto;
}
.inn2-2-1-1 {
  width: 50%;
  margin: 70px 0;
}
.inn2-img {
  margin-left: -40px;
}

.inn3 {
  /* width:1900px; */
  background: white;
  margin: 20px auto 160px;
}
.inn3-2-1-1 {
  width: 50%;
  margin: 0;
}
.con {
  background: #70b597;
  padding: 20px 12px;
}
.inntitle1 {
  position: absolute;
  top: 95px;
  left: 50px;
  color: white;
  font-weight: bold;
  font-size: 30px;
}
.inndesc1 {
  position: absolute;
  top: 185px;
  left: 50px;
  color: white;
  font-size: 14px;
  width: 480px;
}
.inntitle2 {
  position: absolute;
  top: 95px;
  left: 670px;
  color: white;
  font-weight: bold;
  font-size: 30px;
}
.inndesc2 {
  position: absolute;
  top: 185px;
  left: 670px;
  color: white;
  font-size: 14px;
  width: 480px;
}
</style>




// WEBPACK FOOTER //
// src/pages/pcPages/Ainnovate.vue